import { Play, CheckCircle, XCircle, RotateCcw } from 'lucide-react';
import type { Candidate, CandidateStatus } from '../types/candidate.types';

export interface CandidateActionsProps {
  candidate: Candidate;
  onEdit: (candidate: Candidate) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: CandidateStatus) => void;
  onResendInvitation: (id: string) => void;
  onCopyLink: (shareId: string) => void;
}

export interface CandidateActionsMenuProps {
  candidateId: string;
  shareId: string;
  status: CandidateStatus;
  onEdit: () => void;
  onResendInvitation: (id: string) => void;
  onCopyLink: (shareId: string) => void;
  onDelete: () => void;
  onStatusClick: (status: CandidateStatus) => void;
}

export const STATUS_CONFIG: Record<CandidateStatus, { icon: typeof Play; label: string }> = {
  DRAFT: { icon: RotateCcw, label: 'Move to Draft' },
  PENDING: { icon: Play, label: 'Submit for Review' },
  CONFIRMED: { icon: CheckCircle, label: 'Confirm' },
  REJECTED: { icon: XCircle, label: 'Reject' },
};
